import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';

import {
  AppBar,
  Toolbar,
  Typography,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles(({
  root: {},
  toolbar: {
    height: 64
  }
}));

const TopBar = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <AppBar
      className={clsx(classes.root, className)}
      elevation={0}
    >
      <Toolbar className={classes.toolbar}>
        <RouterLink to="/">
          
        </RouterLink>
        <Typography
          color="inherit"
          variant="h4"
        > &nbsp;Sistema Integrado de Manutenção e Monitoramento
        </Typography>
      </Toolbar>
    </AppBar>
  );
};


export default TopBar;
